import request from '@/utils/request'

export const getOrgList = ({ page, size, keywords: orgName }) => {
  return request({
    url: `/upms/org/${page}/${size}`,
    params: {
      orgName
    }
  })
}

export const putOrgAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/org',
    data
  })
}

export const putOrgintroductionAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/orgintroduction',
    data
  })
}

export const postOrgEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/org',
    data
  })
}

export const postOrgintroductionEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/orgintroduction',
    data
  })
}

export const getOrgDetail = (id) => {
  return request({
    url: `/upms/org/${id}`
  })
}

export const getOrgintroductionDetail = (orgId) => {
  return request({
    url: `/upms/orgintroduction/${orgId}`
  })
}

export const deleteOrgDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/org/${id}`
  })
}

export const delOrgList = (data) => {
  return request({
    method: 'delete',
    url: '/upms/org/all',
    data
  })
}
